module.exports = __webpack_public_path__ + "img/sutherland-elliot.9451e8f4.jpg";